export default "__VITE_ASSET__BlhukLXF__"